
import sysEg1 from "../assets/Egypt/systel/1x.jpg";
import sysEg2 from "../assets/Egypt/systel/2x.jpg";
import sysEg3 from "../assets/Egypt/systel/3x.jpg";
import sysEg4 from "../assets/Egypt/systel/4x.jpg";
import sysEg5 from "../assets/Egypt/systel/5x.jpg";
import sysEg6 from "../assets/Egypt/systel/6x.jpg";
import sysEg7 from "../assets/Egypt/systel/7x.jpg";
import sysEg8 from "../assets/Egypt/systel/8x.jpg";
import sysEg9 from "../assets/Egypt/systel/9x.jpg";
import sysEg10 from "../assets/Egypt/systel/10x.jpg";

import pro4Qr1 from "../assets/qatar/project 4/01-min.jpg";
import pro4Qr2 from "../assets/qatar/project 4/02-min.jpg";
import pro4Qr3 from "../assets/qatar/project 4/03-min.jpg";
import pro4Qr4 from "../assets/qatar/project 4/04-min.jpg";
import pro4Qr5 from "../assets/qatar/project 4/05-min.jpg";
import pro4Qr6 from "../assets/qatar/project 4/06-min.jpg";
import pro4Qr7 from "../assets/qatar/project 4/07-min.png";


import pro5Qr1 from "../assets/qatar/pr5/Opt 4-min.jpg";
import pro5Qr2 from "../assets/qatar/pr5/g3-min.jpg";
import pro5Qr5 from "../assets/qatar/pr5/g4-min.jpg";
import pro5Qr3 from "../assets/qatar/pr5/opt 2-min.jpg";
import pro5Qr4 from "../assets/qatar/pr5/opt 3-min.jpg";







export const projectsData = {
    egypt: {
        name: "Egypt",
        projects: {
            fertiglobe: {
                id: "fertiglobe",
                name: "Fertiglobe Project",
                cover: "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011262/7_dnhl9w.jpg",
                images: ["https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011262/7_dnhl9w.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011298/13_ghhzgh.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011295/8_qig0rm.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011293/5_h8utb6.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011291/12_r25lhd.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011290/1_anfnvw.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011266/2_dzridr.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011308/6_zaxd5i.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011256/4_g5mbkk.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011253/9_xodprc.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011248/3_qoznlg.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011237/10_plnihe.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760011232/11_oiry4t.jpg",
],
            },
            render: {
                id: "render",
                name: "Renders Project",
                cover: "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012154/1_qdcijk.jpg",
                images: ["https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012193/11_a1zgxp.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012224/13_lrbebb.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012220/14_gqpdrq.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012208/12_xotaey.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012207/10_kssctj.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012199/8_et4nyp.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012195/9_qyin31.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012192/6_butaha.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012178/7_yunksu.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012159/3_hfcedz.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012154/2_at4xna.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012154/1_qdcijk.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012139/5_dkvcag.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760012149/4_fpgs8f.jpg",
                        ],
            },
            systel: {
                id: "systel",
                name: "Systel Project",
                cover: sysEg10,
                images: [sysEg1, sysEg2, sysEg3, sysEg4, sysEg5, sysEg6, sysEg7, sysEg8, sysEg9, sysEg10],
            },
        },
    },
    qatar: {
        name: "Qatar",
        projects: {
            majlis: {
                id: "majlis",
                name: "majlis Project",
                cover: "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014010/1_btesol.jpg",
                images: [
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014010/1_btesol.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014057/10_pfknqd.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014048/8_rro1ds.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014046/9_bsq8cx.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014045/11_zfzyew.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014017/5_jql50j.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014015/3_dxfpac.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014014/7_lrtgzk.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014014/6_ikewl0.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760014009/4_gga0co.jpg",

                ],
            },
             project2: {
                id: "project2",
                name: "project2",
                cover: "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013177/CAM_0_f33kqr.jpg",
                images: ["https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013177/CAM_0_f33kqr.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013232/CAM_22_wwii2m.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013227/CAM_20_ocjt73.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013223/CAM_19_hf7cqp.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013220/CAM_13_lvf55w.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013219/CAM_10_sc6kah.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013219/CAM_9_xdoog3.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013211/CAM_7_fy3gpd.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013198/CAM_1_rsnk2t.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013200/CAM_6_on0lh6.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013192/CAM_3_u4uofb.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013180/CAM_4_qh4pvg.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013209/CAM_8_rc2yrp.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013180/CAM_4_qh4pvg.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760013184/CAM_5_kk7pvy.jpg",
                ],
            },
             project3: {
                id: "project3",
                name: "project3",
                cover: "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015680/2-2-min_okaast.jpg",
                images: ["https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015680/2-2-min_okaast.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015685/4-2-min_jltltv.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015684/1-2-min_jjbdp6.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015682/3-2-min_s7kknc.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015691/5-2-min_uxrlaf.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015689/6-2-min_lbv6ol.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015710/7-2-min_rzkvxg.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015712/12-2-min_g6qeml.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015733/8-2-min_jwpwye.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015733/15-2-min_fpi2ct.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015734/10-2-min_eyhqha.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015734/9-2-min_f9vj4n.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015742/11-2-min_wmoilg.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015750/14-2-min_sugx3c.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015755/17-2-min_iqbqgj.jpg",
                            "https://res.cloudinary.com/dpp4tvpwp/image/upload/v1760015762/16-2-min_nrsw7o.jpg",
                ],
            },
             project4: {
                id: "project4",
                name: "project4",
                cover: pro4Qr1,
                images: [pro4Qr1, pro4Qr2, pro4Qr3, pro4Qr4, pro4Qr5, pro4Qr6, pro4Qr7],
            },
             project5: {
                id: "project5",
                name: "project5",
                cover: pro5Qr1,
                images: [pro5Qr1, pro5Qr2, pro5Qr3, pro5Qr4, pro5Qr5],
            },
        },
    },
};
